import ReactDOM from "react-dom/client";
import { App } from "./App";
import { store } from "./service/store";
import { Provider } from "react-redux";
import React from "react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
// HTTPS=true SSL_CRT_FILE=./SSL_certificate/xpresspayments_com.pem SSL_KEY_FILE=./SSL_certificate/xpresspayments-decrypted.pem 